module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAA3UlEQVR4nO3awQ2CQBRAQbQCK7BWarUCO9AGDIQYeGSZucISwjstf6cJAAAAAAAY3W3thuf8/ixdf82PxWesrR/d2ve5H/Ui/CZATICYADEBYgLEBAAAADiYecDOzANOToCYADEBYgLEBIgJAAAAcDDzgJ2ZB5ycADEBYgLEBIgJEBMAAADgYKvzgKv5d/6xlZ1wTICYADEBYgLEBIgJEBMgJkBMgJgAseH/BdVnU50NPTkBYgLEBIgJEBMgJkBs+H3AVmbCFyNATICYADEBYgLEBIgJEBMgJkBMgNgXnEMka8HKALUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/additions.png
// module id = 1397
// module chunks = 0